/*eslint-disable */
import { GetFacturaCarteraByFiltersDtoProps } from "api/DTOs/GetFacturaCarteraByFiltersDto"
import { GetFacturaCarteraByFiltersDtoIPagedEnumerable } from "api/Schemas/GetFacturaCarteraByFiltersDtoIPagedEnumerable"
import TesoreriaService from "common/services/TesoreriaService"
import { PAYMENT_TYPE } from "common/utils/constants"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"
import { precisionNumber } from "utils/precisionNumber"

export interface CarteraTableProps {
  id?: GetFacturaCarteraByFiltersDtoProps["id"]
  "librado.razonSocial"?: GetFacturaCarteraByFiltersDtoProps["empresa"]["razonSocial"]
  "librador.razonSocial"?: GetFacturaCarteraByFiltersDtoProps["empresa"]["razonSocial"]
  empresaId?: GetFacturaCarteraByFiltersDtoProps["empresa"]["id"]
  fechaEmision?: GetFacturaCarteraByFiltersDtoProps["fecha"]
  fechaVencimiento?: GetFacturaCarteraByFiltersDtoProps["fechaVencimiento"]
  importe?: GetFacturaCarteraByFiltersDtoProps["importe"]
  importePendiente?: GetFacturaCarteraByFiltersDtoProps["importePendiente"]
  numero?: GetFacturaCarteraByFiltersDtoProps["numero"]
}
export interface PagoCobroLineProps {
  data: {
    empresaId?: string
    facturaId?: string
    fecha?: string
    importe?: number
    razonSocial?: string
    remesaId?: string
    tipo?: number
  } | null
  status: boolean
}

export const getToggleButtons = (
  setTabSelected: $TSMigrationFixMe,
  clearRemesaSelection: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return [
    {
      id: 2,
      handleClick: () => {
        clearRemesaSelection()
        setTabSelected(PAYMENT_TYPE_CARTERA_ACTION_SETTINGS(t)[2].value)
      },
      label: `${PAYMENT_TYPE_CARTERA_ACTION_SETTINGS(t)[2].label}s`,
      disabled: false,
    },
    {
      id: 1,
      handleClick: () => {
        clearRemesaSelection()
        setTabSelected(PAYMENT_TYPE_CARTERA_ACTION_SETTINGS(t)[1].value)
      },
      label: `${PAYMENT_TYPE_CARTERA_ACTION_SETTINGS(t)[1].label}s`,
      disabled: false,
    },
  ]
}

export const CARTERA_COLUMNS = (
  t: TFunction,
  onRenderCheckIcon: (rowData: CarteraTableProps) => JSX.Element,
  handleOpenModalFacturaDetail: (facturaId: string) => void,
  tabSelected: number
) => {
  const columns = [
    {
      key: "fechaEmision",
      header: `${t("cartera.tab.headerDate")}`,
      field: "fechaEmision",
      className: "tw-text-text",
      style: { width: "10%" },
      sortable: true,
      sortfield: "fechaEmision",
      body: ({ fechaEmision }: CarteraTableProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "-",
    },
    {
      key: "FechaVencimiento",
      header: `${t("cartera.tab.headerDateVencimiento")}`,
      field: "fechaVencimiento",
      style: { width: "10%" },
      className: "tw-text-text !tw-pl-6",
      sortable: true,
      sortfield: "fechaVencimiento",
      body: ({ fechaVencimiento }: CarteraTableProps) =>
        fechaVencimiento ? frontendDateFormat(new Date(fechaVencimiento)) : "-",
    },
    {
      key: "empresa",
      header: `${t("cartera.tab.headerCompanyName")}`,
      field:
        tabSelected === PAYMENT_TYPE.COBRO
          ? "librado.razonSocial"
          : "librador.razonSocial",
      style: { width: "25%" },
      className: "tw-text-text",
      sortable: true,
      sortfield: "empresa",
    },
    {
      key: "Numero",
      header: `${t("cartera.tab.headerDoc")}`,
      field: "numero",
      className: "tw-text-text tw-text-left tw-cursor-default",
      style: { width: "15%" },
      sortable: true,
      sortfield: "numero",
      body: ({ numero, id }: CarteraTableProps) => {
        return (
          <span
            key={numero}
            className={`tw-cursor-pointer ${
              id ? "tw-text-info hover:tw-underline" : ""
            }`}
            onClick={() => id && handleOpenModalFacturaDetail(id)}
          >
            {numero}
          </span>
        )
      },
    },
    {
      key: "Importe",
      header: `${t("cartera.tab.headerTax")}`,
      field: "importe",
      className: "tw-text-text !tw-text-right",
      style: { width: "15%" },
      sortable: true,
      sortfield: "importe",
      alignCol: "right",
      body: ({ importe }: CarteraTableProps) =>
        `${new Intl.NumberFormat("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(precisionNumber(importe ?? 0))} €`,
    },
    {
      key: "importePendiente",
      header: `${t("cartera.tab.headerPendding")}`,
      field: "importePendiente",
      style: { width: "15%" },
      className: "!tw-text-right",
      alignCol: "right",
      sorter: false,
      body: ({ importePendiente }: CarteraTableProps) =>
        `${new Intl.NumberFormat("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(precisionNumber(importePendiente ?? 0))} €`,
    },
    {
      key: "Boton",
      field: "",
      className: "tw-text-text !tw-p-2",
      sorter: false,
      body: (rowData: CarteraTableProps) => (
        <span className='tw-w-full tw-flex tw-flex-row tw-justify-end tw-items-center'>
          {onRenderCheckIcon(rowData)}
        </span>
      ),
    },
  ]
  return columns
}

export const getTotals = (array: $TSMigrationFixMe, key: $TSMigrationFixMe) => {
  return array?.reduce(
    (a: $TSMigrationFixMe, b: $TSMigrationFixMe) => a + b[key],
    0
  )
}

export const getIdsFromDocumentos = (documentSelected: $TSMigrationFixMe) => {
  return documentSelected?.map((documents: $TSMigrationFixMe) => documents.id)
}

export const PAYMENT_TYPE_CARTERA_ACTION_SETTINGS = (t: $TSMigrationFixMe) => {
  return {
    [PAYMENT_TYPE.COBRO]: {
      // CLIENTE
      label: `${t("cartera.labelPortfolioCollection")}`,
      title: `${t("cartera.labelCollection")}`,
      postService: TesoreriaService.createCobroFactura,
      deleteService: TesoreriaService.deleteCobro,
      value: PAYMENT_TYPE.COBRO,
    },
    [PAYMENT_TYPE.PAGO]: {
      // PROVEEDOR
      label: `${t("cartera.labelPortfolioPayment")}`,
      title: `${t("cartera.labelPayment")}`,
      postService: TesoreriaService.createPagoFactura,
      deleteService: TesoreriaService.deletePago,
      value: PAYMENT_TYPE.PAGO,
    },
  }
}

export const adapterCarteraLibrador = (
  cartera: GetFacturaCarteraByFiltersDtoIPagedEnumerable
) =>
  cartera.items.map((factura: GetFacturaCarteraByFiltersDtoProps) => ({
    id: factura.id,
    "librador.razonSocial": factura.empresa?.razonSocial,
    "librado.razonSocial": factura.empresa?.razonSocial,
    empresaId: factura?.empresa?.id,
    fechaEmision: factura.fecha,
    fechaVencimiento: factura.fechaVencimiento,
    importe: factura.importe,
    importePendiente: factura.importePendiente,
    numero: factura.numero,
  }))
